function parseNumberish(value) {
  if (value == null) return null;
  if (typeof value === 'number') {
    return Number.isFinite(value) ? value : null;
  }
  if (typeof value === 'string') {
    const cleaned = value.trim();
    if (!cleaned) return null;
    let normalized = cleaned;
    if (cleaned.includes(',') && cleaned.includes('.')) {
      if (cleaned.lastIndexOf(',') > cleaned.lastIndexOf('.')) {
        normalized = cleaned.replace(/\./g, '').replace(',', '.');
      } else {
        normalized = cleaned.replace(/,/g, '');
      }
    } else if (cleaned.includes(',')) {
      normalized = cleaned.replace(',', '.');
    }
    const parsed = Number(normalized);
    return Number.isFinite(parsed) ? parsed : null;
  }
  return null;
}

function centsToReais(value) {
  const parsed = parseNumberish(value);
  if (!Number.isFinite(parsed)) return null;
  return Math.max(0, parsed / 100);
}

function reaisFromUnknown(value) {
  const parsed = parseNumberish(value);
  if (!Number.isFinite(parsed)) return null;
  return Math.max(0, parsed);
}

export function hasActivePromotion(product) {
  return Boolean(product?.promotion?.is_active);
}

export function getPromotionDiscountPercent(product) {
  const percent = parseNumberish(
    product?.promotion?.total_discount_percent
      ?? product?.promotion?.discount_percent
      ?? 0
  );
  return Number.isFinite(percent) ? Math.max(0, percent) : 0;
}

export function getPromotionalPriceReais(product) {
  if (!hasActivePromotion(product)) return null;

  const fromPromotionCents = centsToReais(product?.promotion?.final_price_cents);
  if (fromPromotionCents != null) return fromPromotionCents;

  const fromPromotion = reaisFromUnknown(product?.promotion?.final_price);
  if (fromPromotion != null) return fromPromotion;

  const fromFieldCents = centsToReais(product?.price_promotional_cents);
  if (fromFieldCents != null) return fromFieldCents;

  const fromField = reaisFromUnknown(product?.price_promotional);
  if (fromField != null) return fromField;

  return null;
}

export function getStandardProductPriceReais(product) {
  const fromPrecoOriginal = reaisFromUnknown(product?.preco_original);
  if (fromPrecoOriginal != null) return fromPrecoOriginal;

  const fromPriceOriginalCents = centsToReais(product?.price_original_cents);
  if (fromPriceOriginalCents != null) return fromPriceOriginalCents;

  const fromPreco = reaisFromUnknown(product?.preco);
  if (fromPreco != null) return fromPreco;

  const fromPriceCents = centsToReais(product?.price_cents);
  if (fromPriceCents != null) return fromPriceCents;

  const rawPrice = parseNumberish(product?.price);
  if (rawPrice != null) {
    if (Number.isInteger(rawPrice) && rawPrice > 1000) {
      return rawPrice / 100;
    }
    return rawPrice;
  }

  const fromCentavos = centsToReais(product?.preco_centavos);
  if (fromCentavos != null) return fromCentavos;

  return 0;
}

export function getDisplayedBasePriceReais(product) {
  return getPromotionalPriceReais(product) ?? getStandardProductPriceReais(product);
}
